import {
  REQUEST_STATUS_NAME,
  REQUEST_APPROVED_STATUSES,
  RequestStatus,
} from 'modules/request'
import {Tag} from 'common/components'

interface BorrowerProjectTagProps {
  project: any
}

export default function BorrowerProjectTag({project}: BorrowerProjectTagProps) {
  if (project.status === 'declined')
    return (
      <Tag icon="close" color="danger">
        Request declined
      </Tag>
    )

  const [request] = project.loanRequests

  if (
    project.status === 'pending' &&
    REQUEST_APPROVED_STATUSES.includes(request.status)
  ) {
    return (
      <Tag icon="request" color="success">
        {REQUEST_STATUS_NAME[request.status as RequestStatus]}
      </Tag>
    )
  }

  return (
    <Tag icon="request" color="warning">
      Pending approval
    </Tag>
  )
}
